import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { ArrowRight, Calendar } from "@phosphor-icons/react";

export default function NewsCard({ article, lang }) {
  const { t } = useI18n();
  const title = lang === "en" ? article.title_en : article.title_it;
  const excerpt = lang === "en" ? article.excerpt_en : article.excerpt_it;
  const date = new Date(article.published_at).toLocaleDateString(
    lang === "en" ? "en-GB" : "it-IT",
    { day: "2-digit", month: "long", year: "numeric" }
  );

  return (
    <Link
      to={`/news/${article.slug}`}
      data-testid={`news-card-${article.slug}`}
      className="group card-elegant block bg-white"
    >
      <div className="img-zoom aspect-[16/10] overflow-hidden bg-[#0A1428]/5">
        <img
          src={article.image}
          alt={title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-6 lg:p-8">
        <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-[#4A5568] mb-4">
          <span className="text-[#C5A059] font-semibold">{article.category}</span>
          <span className="text-[#0A1428]/20">•</span>
          <span className="flex items-center gap-1.5">
            <Calendar size={12} />
            {date}
          </span>
        </div>
        <h3 className="font-serif text-2xl text-[#0A1428] leading-tight font-medium group-hover:text-[#C5A059] transition-colors">
          {title}
        </h3>
        <p className="mt-4 text-[#4A5568] leading-relaxed line-clamp-3">{excerpt}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-[#C5A059]">
          {t.news.readMore} <ArrowRight size={14} weight="bold" />
        </span>
      </div>
    </Link>
  );
}
